'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background: ', ';\n  border-radius: 100%;\n  border: 2px solid ', ';\n  transition: all 200ms ease;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n  align-self: flex-start;\n  height: 20px;\n  width: 20px;\n'], ['\n  background: ', ';\n  border-radius: 100%;\n  border: 2px solid ', ';\n  transition: all 200ms ease;\n  margin-right: 0.5rem;\n  flex-shrink: 0;\n  align-self: flex-start;\n  height: 20px;\n  width: 20px;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Button = _styledComponents2.default.div(_templateObject, _config.colors.white, _config.colors.gray);

Button.displayName = 'Button';

exports.default = Button;